import { createAction, props } from '@ngrx/store';
import { LeadAppLinkEntity } from '../../../entities/mdqx/leadapp/lead-app-link.entity';
import { LinkAddRequest, LinkDeleteRequest, LinkEditRequest } from '@mdqx/types';
import { GatewayResponseErrorType } from '../../../services/app-gateway.service';
import { UploadActionProps } from '../../../guards/resolver.helper';

const prefix = 'data/' + 'lead-app-link/';
export const LeadAppLinkActionTypes = {
    GetRequest: createAction(prefix + 'get/request', props< UploadActionProps >()),
    GetSuccess: createAction(prefix + 'get/success', props<{ Payload: LeadAppLinkEntity[], updateLatestUpdatedAt: boolean }>()),
    GetFailure: createAction(prefix + 'get/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    LeadAppLinkCreateDataEntriesSuccess: createAction(prefix + 'lead-app-link-create-data-entries-success/success', props<{ Payload: LeadAppLinkEntity }>()),
    GetLinkRequestById: createAction(prefix + 'get-by-id/request', props<{ Payload: string }>()),

    AddRequest: createAction(prefix + 'add/request', props<{ Payload: LinkAddRequest }>()),
    AddSuccess: createAction(prefix + 'add/success', props<{ Payload: LeadAppLinkEntity }>()),
    AddFailure: createAction(prefix + 'add/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    EditRequest: createAction(prefix + 'change/request', props<{ Payload: LinkEditRequest }>()),
    EditSuccess: createAction(prefix + 'change/success', props<{ Payload: LeadAppLinkEntity }>()),
    EditFailure: createAction(prefix + 'change/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    DeleteRequest: createAction(prefix + 'delete/request', props<{ Payload: LinkDeleteRequest }>()),
    DeleteSuccess: createAction(prefix + 'delete/success', props<{ Payload: string }>()),
    DeleteFailure: createAction(prefix + 'delete/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
}
